export const sharedTableStyles = {
    table: {
        style: {
            backgroundColor: "#111111",
            color: "#e5e7eb",
            fontSize: "13px",
            borderRadius: "0",
        },
    },
    tableWrapper: {
        style: {
            borderRadius: "0",
        },
    },
    header: {
        style: {
            borderRadius: "0",
        },
    },
    headRow: {
        style: {
            backgroundColor: "#1c1c1c",
            borderBottom: "1px solid #2d2d2d",
            minHeight: "40px",
            borderRadius: "0",
        },
    },
    headCells: {
        style: {
            color: "#9ca3af",
            fontWeight: "600",
            fontSize: "11px",
            textTransform: "uppercase" as const,
            letterSpacing: "0.06em",
            paddingLeft: "12px",
            paddingRight: "12px",
        },
    },
    rows: {
        style: {
            backgroundColor: "#111111",
            color: "#e5e7eb",
            borderBottom: "1px solid #1f1f1f",
            minHeight: "44px",
            fontSize: "13px",
        },
        highlightOnHoverStyle: {
            backgroundColor: "#1a1a1a",
            color: "#e5e7eb",
            cursor: "pointer",
            outline: "none",
            borderBottom: "1px solid #1f1f1f",
        },
    },
    cells: {
        style: {
            paddingLeft: "12px",
            paddingRight: "12px",
            paddingTop: "6px",
            paddingBottom: "6px",
        },
    },
    pagination: {
        style: {
            backgroundColor: "#111111",
            color: "#9ca3af",
            borderTop: "1px solid #2d2d2d",
            fontSize: "13px",
            minHeight: "52px",
        },
        pageButtonsStyle: {
            color: "#9ca3af",
            fill: "#9ca3af",
            backgroundColor: "#1c1c1c",
            borderRadius: "4px",
            height: "30px",
            width: "30px",
            padding: "4px",
            margin: "0 2px",
            cursor: "pointer",
            border: "1px solid #2d2d2d",
            "&:disabled": {
                color: "#3f3f3f",
                fill: "#3f3f3f",
                cursor: "not-allowed",
                backgroundColor: "#161616",
                border: "1px solid #222222",
            },
            "&:hover:not(:disabled)": {
                backgroundColor: "#2a2a2a",
                color: "#e5e7eb",
                fill: "#e5e7eb",
            },
            "&:focus": {
                outline: "none",
                backgroundColor: "#2a2a2a",
            },
        },
    },
    noData: {
        style: {
            backgroundColor: "#111111",
            color: "#6b7280",
            padding: "40px 20px",
        },
    },
    progress: {
        style: {
            backgroundColor: "#111111",
            color: "#e5e7eb",
            padding: "40px 20px",
        },
    },
};